/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Health_DescriptionInputs */

const en_legal_health_description = /** @type {(inputs: Legal_Health_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For consumers in Washington and Nevada.`)
};

const pl_legal_health_description = /** @type {(inputs: Legal_Health_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla konsumentów w stanach Waszyngton i Nevada.`)
};

/**
* | output |
* | --- |
* | "For consumers in Washington and Nevada." |
*
* @param {Legal_Health_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_health_description = /** @type {((inputs?: Legal_Health_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Health_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_health_description(inputs)
	return en_legal_health_description(inputs)
});